import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BackButtonComponent } from '../../../shared/components/back-button/back-button.component';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { CardContentComponent } from '../../../shared/components/card/card-content.component';
import { CardComponent } from '../../../shared/components/card/card.component';
import { IconComponent } from '../../../shared/components/icon/icon.component';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';

/** Cross-organization QA tools -- gated by superAdminGuard at the route level
 *  (see app.routes.ts), so this component doesn't re-check permissions itself. */
@Component({
  selector: 'app-settings-admin',
  standalone: true,
  imports: [RouterLink, BackButtonComponent, CardComponent, CardContentComponent, ButtonComponent, IconComponent, TranslatePipe],
  templateUrl: './settings-admin.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./settings-admin.component.css', '../../../../css/settings-shared.css'],
})
export class SettingsAdminComponent {}
